module.exports = __webpack_public_path__ + "static/media/value_prop_banner.3b976b78.svg";